export const MSG_ERROR_AGENDATE_TYPE = 'Debe indicar el tipo de agendamiento';
export const MSG_ERROR_NOTIFICATION_CREATE = 'No se puede generar la Notificación';
export const MSG_ERROR_NOTIFICATION_EMAIL = 'No se puede generar la Notificación, no tiene E-mail asignado';
export const MSG_ERROR_SELECT_FILTER = 'Debe seleccionar un filtro para realizar la búsqueda';
export const MSG_ERROR_SERVER = 'Error al conectarse al servidor';

export const NOT_AVAILABLE = "N/D";

export const MSG_CHANGING_PASSWORD = 'Actualizando contraseña';
export const MSG_DOWNLOADING = 'Descargando...';
export const MSG_GENERATING_PREVIEW = 'Generando vista previa';
export const MSG_LOADING_INFORMATION = 'Cargando información';
export const MSG_LOGIN_IN = 'Iniciando sesión';
export const MSG_SEARCHING_AUDIENCE = 'Buscando audiencia';
export const MSG_UPDATING_PROFILE = 'Actualizando perfil';

export const MSG_CREATE_SUCCESS = 'Registro creado!!!';
export const MSG_DELETE_SUCCESS = 'Registro eliminado!!!';
export const MSG_DELETING = 'Eliminando registro';
export const MSG_UPDATE_SUCCESS = 'Registro actualizado!!!';

export const MSG_DELETE = 'Eliminar registro?';
export const MSG_NOT_REVERT_OPERATION = 'No se podrá revertir la operación';

export const MSG_AGENDATE_SUCCESS = 'Audiencia agendada correctamente!!!';
export const MSG_ANULATE_SUCCESS = 'Solicitud anulada correctamente!!!';
export const MSG_ANULATE_ACCUSED_RESULT_SUCCESS = 'Resultado anulado correctamente!!!';
export const MSG_APPROVE_SUCCESS = 'Aprobado/a correctamente!!!';
export const MSG_CANCEL_SUCCESS = 'Cancelado/a correctamente!!!';
export const MSG_FINALIZE_SUCCESS = 'Finalizado/a correctamente!!!';
export const MSG_REJECT_SUCCESS = 'Rechazado/a correctamente!!!';
export const MSG_RESERVE_SUCCESS = 'Reservado/a correctamente!!!';
export const MSG_RESORTEO_MOTIVO = 'Seleccione el Motivo';
export const MSG_RESORTEO_SUCCESS = 'Juez resorteado correctamente!!!';
export const MSG_REVOKE_SUCCESS = 'Revocado/a correctamente!!!';
export const MSG_UNRESERVE_SUCCESS = 'Quitado de Reserva correctamente!!!';

export const MSG_CLONE_AUDIENCE_SUCCESS = 'Audiencia duplicada correctamente!!!';
export const MSG_MIGRATE_ACT_SUCCESS = 'Acta migrada a SAE correctamente!!!';
export const MSG_RESET_PASSWORD_SUCCESS = 'La contraseña fue reseteada correctamente!!!';
export const MSG_SAVE_ACCUSED_RESULT_SUCCESS = 'Resultado de Imputado cargado correctamente!!!';
export const MSG_UPDATE_ACCUSED_SUCCESS = 'Datos de Imputado actualizados!!!';
export const MSG_UPDATE_OFIJU_SUCCESS = 'Datos de Ofiju actualizados!!!';
export const MSG_UPDATE_OPERATOR_SUCCESS = 'Datos de Operador actualizados!!!';
export const MSG_UPDATE_PROCEEDING_SUCCESS = 'Datos de Expediente actualizados!!!';
export const MSG_UPDATE_PROSECUTOR_SUCCESS = 'Datos de Fiscal/Fiscalía actualizados!!!';
export const MSG_UPDATE_SALA_SUCCESS = 'Datos de la Sala actualizados!!!';   
export const MSG_UPDATE_SCHEDULED_END_SUCCESS = "Horario Actualizado!!!";
export const MSG_UPDATE_SESSION_SUCCESS = 'Datos de Enlace remoto actualizados!!!';
export const MSG_UPDATE_VICTIM_SUCCESS = 'Datos de Víctima actualizados!!!';

export const MSG_USER_CREATE_SUCCESS = 'Usuario creado correctamente!!!';
export const MSG_USER_NO_EMAIL_CREATE_SUCCESS = 'Usuario creado correctamente!!! Pero no se pudo enviar el email, contraseña generada: ';

export const MSG_CHANGE_PASSWORD_SUCCESS = 'Su contraseña ha sido actualizada correctamente!!';
export const MSG_GET_RESET_PASSWORD_TOKEN = 'Se ha enviado un email con los pasos para resetear su contraseña.';
export const MSG_UPDATE_PROFILE_SUCCESS = 'Su perfil ha sido actualizado correctamente!!';